<template>
  <path
    d="M19.8 10.7002L5.15 5.35016C4.63 5.16016 4.05 5.43016 3.85 5.95016C3.66 6.48016 3.93 7.06016 4.45 7.25016L17.6 12.0002H5C3.9 12.0002 3 12.9002 3 14.0002V18.0002C3 19.1002 3.9 20.0002 5 20.0002H19C20.1 20.0002 21 19.1002 21 18.0002V12.5002C21 11.7002 20.5 10.9002 19.8 10.7002ZM7 17.0002H5V15.0002H7V17.0002ZM18 17.0002H10C9.45 17.0002 9 16.5502 9 16.0002C9 15.4502 9.45 15.0002 10 15.0002H18C18.55 15.0002 19 15.4502 19 16.0002C19 16.5502 18.55 17.0002 18 17.0002Z"
  />
</template>
